module.exports = __webpack_public_path__ + "img/ico-left.a84f000c.svg";